import { render, staticRenderFns } from "./DocumentGroupFilter.vue?vue&type=template&id=5862b162&scoped=true&"
import script from "./DocumentGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./DocumentGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862b162",
  null
  
)

export default component.exports